import { createContext, useContext } from "react";

export const HorizontalScrollMultiplierContext = createContext<number>(1);

export const useHorizontalScrollMultiplier = () =>
  useContext(HorizontalScrollMultiplierContext);
